import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from './Skeleton';
export const TextSkeleton = ({ lines = 1, width = '100%', lastLineWidth = '70%', height = 16, spacing = 8, animation = 'shimmer', radius, className, style, ...rest }) => {
    const lineCount = Math.max(lines, 1);
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: `${spacing}px`,
        ...style,
    };
    return (_jsx("div", { className: className, style: containerStyle, role: "status", "aria-label": "Loading text content", ...rest, children: Array.from({ length: lineCount }).map((_, index) => {
            const isLast = index === lineCount - 1;
            const lineWidth = isLast ? lastLineWidth : width;
            return (_jsx(Skeleton, { animation: animation, radius: radius, style: { width: lineWidth, height } }, index));
        }) }));
};
